<kendo-card  *ngIf="currStep" [width]="'auto'">
  <div class="k-vbox">
  <kendo-card-header>
    <h6 kendoCardSubtitle class="d-flex align-items-center">{{'current_step_title' | i18n}} <help-link [target]="helpTarget"></help-link></h6>
    <h5 kendoCardTitle>{{ currStep.payload.data.title }}</h5>
  </kendo-card-header>
  <div class="d-flex justify-content-between flex-column card-wrap">
    <kendo-card-body>
      <div class="d-flex flex-row mb-3 align-items-center">
        <div class="label"> {{'step_details_label_assignee' | i18n}}: </div>
        <div class="d-flex flex-column pt-1">
          <div *ngFor="let a of uniqueAssignees" class="d-flex flex-column align-items-start">          
            <circ-task-details class="assignees" [assignee]="a" [showName]="true" [showImage]="false">
            </circ-task-details>
            <div class="d-flex flex-row align-items-center ml-3 forward">
              <circ-step-current-forwarded [currentAssignee]="a" [assignees]="currStep.tasks.assignees">
              </circ-step-current-forwarded>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-center">
        <div class="label">{{'step_details_label_due' | i18n}}:</div>
        <kendo-icon name="calendar" themeColor="primary"></kendo-icon>
        {{ currStep.dueDate | i18nDate:{ date: "medium" } }}
      </div>
      <div class="d-flex flex-row align-items-center comment">
        <kendo-icon name="info" themeColor="primary"></kendo-icon>
        {{ currStep.payload.data.comment}}
      </div>
    </kendo-card-body>
    <hr *ngIf="currStep.canWorkStep" kendoCardSeparator class="py-0" />
    <kendo-card-actions [layout]="'stretched'" *ngIf="currStep.canWorkStep">
      <ece-btn-taskEdit
        [title]="'step_details_steps_work_title' | i18n" (click)="onWork(currStep)">
        {{'step_details_steps_work_btn' | i18n}}</ece-btn-taskEdit>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <ece-btn-forward
        [title]="'step_details_steps_forward' | i18n" (click)="onForward(currStep)">
        {{'step_details_steps_forward' | i18n}}</ece-btn-forward>
    </kendo-card-actions>
  </div>
</div>
<div class="mobile-action-buttons" (click)="toggleActions == !toggleActions">
  <div *ngIf="toggleActions">
    <ece-btn-taskEdit [style.visibility]="currStep.canWorkStep ? 'visible' : 'hidden'"
      [title]="'step_details_steps_work_title' | i18n" (click)="onWork(currStep)" [attr.circButton]="'check'">
      {{'step_details_steps_work_btn' | i18n}}</ece-btn-taskEdit>
    <hr kendoCardSeparator [orientation]="'vertical'" />
    <ece-btn-forward [style.visibility]="currStep.canWorkStep ? 'visible' : 'hidden'"
      [title]="'step_details_steps_forward' | i18n" (click)="onForward(currStep)" [attr.circButton]="'default'">
      {{'step_details_steps_forward' | i18n}}</ece-btn-forward>
  </div>
</div>
</kendo-card>
